// @flow

import Unit from '@/lib/unit';

export default class {
  static process(unit: Unit) {
    unit.age++;
  }
}



// WEBPACK FOOTER //
// ./src/lib/unit_event/age_event.js